/**
 * podravka.io
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.7.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from './ApiClient';
import AccountReadEmbed from './model/AccountReadEmbed';
import ArticleCreate from './model/ArticleCreate';
import ArticleList from './model/ArticleList';
import ArticleListMetricsRead from './model/ArticleListMetricsRead';
import ArticleMetricsRead from './model/ArticleMetricsRead';
import ArticleOriginWriteEmbed from './model/ArticleOriginWriteEmbed';
import ArticleRead from './model/ArticleRead';
import ArticleState from './model/ArticleState';
import ArticleStateUpdate from './model/ArticleStateUpdate';
import ArticleUpdate from './model/ArticleUpdate';
import ArticleVersionList from './model/ArticleVersionList';
import ArticleVersionRead from './model/ArticleVersionRead';
import ArticleVersionWrite from './model/ArticleVersionWrite';
import AttributeDefinitionCreate from './model/AttributeDefinitionCreate';
import AttributeDefinitionCreateOptions from './model/AttributeDefinitionCreateOptions';
import AttributeDefinitionList from './model/AttributeDefinitionList';
import AttributeDefinitionRead from './model/AttributeDefinitionRead';
import BadRequestError from './model/BadRequestError';
import BadRequestErrorViolations from './model/BadRequestErrorViolations';
import BaseReadEmbed from './model/BaseReadEmbed';
import BrandCreate from './model/BrandCreate';
import BrandList from './model/BrandList';
import BrandListMetricsRead from './model/BrandListMetricsRead';
import BrandMetricsRead from './model/BrandMetricsRead';
import BrandOriginWriteEmbed from './model/BrandOriginWriteEmbed';
import BrandRead from './model/BrandRead';
import BrandReadEmbed from './model/BrandReadEmbed';
import BrandState from './model/BrandState';
import BrandStateUpdate from './model/BrandStateUpdate';
import BrandUpdate from './model/BrandUpdate';
import BrandVersionList from './model/BrandVersionList';
import BrandVersionRead from './model/BrandVersionRead';
import BrandVersionWrite from './model/BrandVersionWrite';
import Comment from './model/Comment';
import CommentCreate from './model/CommentCreate';
import CommentList from './model/CommentList';
import CommentRead from './model/CommentRead';
import CommentUpdate from './model/CommentUpdate';
import CommentVersionList from './model/CommentVersionList';
import CommentVersionRead from './model/CommentVersionRead';
import CommentVersionWrite from './model/CommentVersionWrite';
import ContentSitemapNodeCreate from './model/ContentSitemapNodeCreate';
import ContentSitemapNodeList from './model/ContentSitemapNodeList';
import ContentSitemapNodeRead from './model/ContentSitemapNodeRead';
import ContentTaxonCreate from './model/ContentTaxonCreate';
import ContentTaxonList from './model/ContentTaxonList';
import ContentTaxonRead from './model/ContentTaxonRead';
import CurrentUser from './model/CurrentUser';
import EnergyReadEmbed from './model/EnergyReadEmbed';
import FileCreate from './model/FileCreate';
import FileCreateRead from './model/FileCreateRead';
import FileList from './model/FileList';
import FileListMetricsRead from './model/FileListMetricsRead';
import FileMetricsRead from './model/FileMetricsRead';
import FileOriginWriteEmbed from './model/FileOriginWriteEmbed';
import FileRead from './model/FileRead';
import FileState from './model/FileState';
import FileStateUpdate from './model/FileStateUpdate';
import FileUpdate from './model/FileUpdate';
import FileUpdateRead from './model/FileUpdateRead';
import FileVersionList from './model/FileVersionList';
import FileVersionRead from './model/FileVersionRead';
import FileVersionWrite from './model/FileVersionWrite';
import ForbiddenError from './model/ForbiddenError';
import ImageConfigAspectRatioCreate from './model/ImageConfigAspectRatioCreate';
import ImageConfigAspectRatioList from './model/ImageConfigAspectRatioList';
import ImageConfigAspectRatioOriginWriteEmbed from './model/ImageConfigAspectRatioOriginWriteEmbed';
import ImageConfigAspectRatioRead from './model/ImageConfigAspectRatioRead';
import ImageConfigInstanceReadEmbed from './model/ImageConfigInstanceReadEmbed';
import ImageConfigInstanceWriteEmbed from './model/ImageConfigInstanceWriteEmbed';
import ImageConfigVariationCreate from './model/ImageConfigVariationCreate';
import ImageConfigVariationCreateFilters from './model/ImageConfigVariationCreateFilters';
import ImageConfigVariationList from './model/ImageConfigVariationList';
import ImageConfigVariationOriginWriteEmbed from './model/ImageConfigVariationOriginWriteEmbed';
import ImageConfigVariationRead from './model/ImageConfigVariationRead';
import ImageConfigVariationUpdate from './model/ImageConfigVariationUpdate';
import ImageCreate from './model/ImageCreate';
import ImageCreateRead from './model/ImageCreateRead';
import ImageFormatReadEmbed from './model/ImageFormatReadEmbed';
import ImageList from './model/ImageList';
import ImageListMetricsRead from './model/ImageListMetricsRead';
import ImageMetadata from './model/ImageMetadata';
import ImageMetadataUpdate from './model/ImageMetadataUpdate';
import ImageMetricsRead from './model/ImageMetricsRead';
import ImageOriginWriteEmbed from './model/ImageOriginWriteEmbed';
import ImageRead from './model/ImageRead';
import ImageReadEmbed from './model/ImageReadEmbed';
import ImageState from './model/ImageState';
import ImageStateUpdate from './model/ImageStateUpdate';
import ImageSwatchColorReadEmbed from './model/ImageSwatchColorReadEmbed';
import ImageUpdate from './model/ImageUpdate';
import ImageUpdateRead from './model/ImageUpdateRead';
import ImageVariationReadEmbed from './model/ImageVariationReadEmbed';
import ImageVariationReadEmbedUrlVars from './model/ImageVariationReadEmbedUrlVars';
import ImageVariationReadEmbedUrlVarsInstance from './model/ImageVariationReadEmbedUrlVarsInstance';
import ImageVersionList from './model/ImageVersionList';
import ImageVersionRead from './model/ImageVersionRead';
import ImageVersionWrite from './model/ImageVersionWrite';
import IngredientCreate from './model/IngredientCreate';
import IngredientList from './model/IngredientList';
import IngredientListMetricsRead from './model/IngredientListMetricsRead';
import IngredientMetricsRead from './model/IngredientMetricsRead';
import IngredientNutritionReadEmbed from './model/IngredientNutritionReadEmbed';
import IngredientNutritionWriteEmbed from './model/IngredientNutritionWriteEmbed';
import IngredientOriginWriteEmbed from './model/IngredientOriginWriteEmbed';
import IngredientRead from './model/IngredientRead';
import IngredientReadEmbed from './model/IngredientReadEmbed';
import IngredientState from './model/IngredientState';
import IngredientStateUpdate from './model/IngredientStateUpdate';
import IngredientUpdate from './model/IngredientUpdate';
import IngredientVersionList from './model/IngredientVersionList';
import IngredientVersionRead from './model/IngredientVersionRead';
import IngredientVersionWrite from './model/IngredientVersionWrite';
import InlineObject from './model/InlineObject';
import InlineObject1 from './model/InlineObject1';
import InlineObject10 from './model/InlineObject10';
import InlineObject11 from './model/InlineObject11';
import InlineObject12 from './model/InlineObject12';
import InlineObject13 from './model/InlineObject13';
import InlineObject14 from './model/InlineObject14';
import InlineObject15 from './model/InlineObject15';
import InlineObject16 from './model/InlineObject16';
import InlineObject17 from './model/InlineObject17';
import InlineObject18 from './model/InlineObject18';
import InlineObject19 from './model/InlineObject19';
import InlineObject2 from './model/InlineObject2';
import InlineObject20 from './model/InlineObject20';
import InlineObject21 from './model/InlineObject21';
import InlineObject22 from './model/InlineObject22';
import InlineObject23 from './model/InlineObject23';
import InlineObject24 from './model/InlineObject24';
import InlineObject25 from './model/InlineObject25';
import InlineObject26 from './model/InlineObject26';
import InlineObject27 from './model/InlineObject27';
import InlineObject3 from './model/InlineObject3';
import InlineObject4 from './model/InlineObject4';
import InlineObject5 from './model/InlineObject5';
import InlineObject6 from './model/InlineObject6';
import InlineObject7 from './model/InlineObject7';
import InlineObject8 from './model/InlineObject8';
import InlineObject9 from './model/InlineObject9';
import InlineResponse200 from './model/InlineResponse200';
import NotAcceptableError from './model/NotAcceptableError';
import NotFoundError from './model/NotFoundError';
import NutrientReadEmbed from './model/NutrientReadEmbed';
import NutrientWriteEmbed from './model/NutrientWriteEmbed';
import PointOfInterestReadEmbed from './model/PointOfInterestReadEmbed';
import PointOfInterestWriteEmbed from './model/PointOfInterestWriteEmbed';
import ProductCreate from './model/ProductCreate';
import ProductList from './model/ProductList';
import ProductListMetricsRead from './model/ProductListMetricsRead';
import ProductMetricsRead from './model/ProductMetricsRead';
import ProductNutritionReadEmbed from './model/ProductNutritionReadEmbed';
import ProductNutritionWriteEmbed from './model/ProductNutritionWriteEmbed';
import ProductOriginWriteEmbed from './model/ProductOriginWriteEmbed';
import ProductRead from './model/ProductRead';
import ProductReadEmbed from './model/ProductReadEmbed';
import ProductState from './model/ProductState';
import ProductStateUpdate from './model/ProductStateUpdate';
import ProductUpdate from './model/ProductUpdate';
import ProductVersionList from './model/ProductVersionList';
import ProductVersionRead from './model/ProductVersionRead';
import ProductVersionWrite from './model/ProductVersionWrite';
import RecipeCreate from './model/RecipeCreate';
import RecipeIngredientGroupReadEmbed from './model/RecipeIngredientGroupReadEmbed';
import RecipeIngredientGroupWriteEmbed from './model/RecipeIngredientGroupWriteEmbed';
import RecipeIngredientReadEmbed from './model/RecipeIngredientReadEmbed';
import RecipeIngredientWriteEmbed from './model/RecipeIngredientWriteEmbed';
import RecipeList from './model/RecipeList';
import RecipeListMetricsRead from './model/RecipeListMetricsRead';
import RecipeMetricsRead from './model/RecipeMetricsRead';
import RecipeNutritionReadEmbed from './model/RecipeNutritionReadEmbed';
import RecipeNutritionWriteEmbed from './model/RecipeNutritionWriteEmbed';
import RecipeOriginWriteEmbed from './model/RecipeOriginWriteEmbed';
import RecipePreparationStepGroupReadEmbed from './model/RecipePreparationStepGroupReadEmbed';
import RecipePreparationStepGroupWriteEmbed from './model/RecipePreparationStepGroupWriteEmbed';
import RecipePreparationStepReadEmbed from './model/RecipePreparationStepReadEmbed';
import RecipePreparationStepWriteEmbed from './model/RecipePreparationStepWriteEmbed';
import RecipeRead from './model/RecipeRead';
import RecipeState from './model/RecipeState';
import RecipeStateUpdate from './model/RecipeStateUpdate';
import RecipeUpdate from './model/RecipeUpdate';
import RecipeVersionList from './model/RecipeVersionList';
import RecipeVersionRead from './model/RecipeVersionRead';
import RecipeVersionWrite from './model/RecipeVersionWrite';
import ServiceUnavailableError from './model/ServiceUnavailableError';
import ShortNameApproveCommentRead from './model/ShortNameApproveCommentRead';
import SitemapCreate from './model/SitemapCreate';
import SitemapList from './model/SitemapList';
import SitemapNodeCreate from './model/SitemapNodeCreate';
import SitemapNodeList from './model/SitemapNodeList';
import SitemapNodeRead from './model/SitemapNodeRead';
import SitemapNodeReadEmbed from './model/SitemapNodeReadEmbed';
import SitemapNodeUpdate from './model/SitemapNodeUpdate';
import SitemapNodeVersionList from './model/SitemapNodeVersionList';
import SitemapNodeVersionRead from './model/SitemapNodeVersionRead';
import SitemapNodeVersionWrite from './model/SitemapNodeVersionWrite';
import SitemapRead from './model/SitemapRead';
import SitemapUpdate from './model/SitemapUpdate';
import TaxonBagCreate from './model/TaxonBagCreate';
import TaxonBagList from './model/TaxonBagList';
import TaxonBagRead from './model/TaxonBagRead';
import TaxonBagUpdate from './model/TaxonBagUpdate';
import TaxonCreate from './model/TaxonCreate';
import TaxonList from './model/TaxonList';
import TaxonPositionWriteEmbed from './model/TaxonPositionWriteEmbed';
import TaxonRead from './model/TaxonRead';
import TaxonReadEmbed from './model/TaxonReadEmbed';
import TaxonState from './model/TaxonState';
import TaxonStateUpdate from './model/TaxonStateUpdate';
import TaxonUpdate from './model/TaxonUpdate';
import TaxonVersionList from './model/TaxonVersionList';
import TaxonVersionRead from './model/TaxonVersionRead';
import TaxonVersionWrite from './model/TaxonVersionWrite';
import TaxonomyCreate from './model/TaxonomyCreate';
import TaxonomyList from './model/TaxonomyList';
import TaxonomyRead from './model/TaxonomyRead';
import TaxonomyReadEmbed from './model/TaxonomyReadEmbed';
import TaxonomyUpdate from './model/TaxonomyUpdate';
import TenantRead from './model/TenantRead';
import TenantReadClients from './model/TenantReadClients';
import UnauthorizedError from './model/UnauthorizedError';
import UserGroupCreate from './model/UserGroupCreate';
import UserGroupList from './model/UserGroupList';
import UserGroupRead from './model/UserGroupRead';
import UserGroupUpdate from './model/UserGroupUpdate';
import UserList from './model/UserList';
import UserRead from './model/UserRead';
import UserReadEmbed from './model/UserReadEmbed';
import UserUpdate from './model/UserUpdate';
import VersionReadEmbed from './model/VersionReadEmbed';
import VideoCreate from './model/VideoCreate';
import VideoCreateRead from './model/VideoCreateRead';
import VideoList from './model/VideoList';
import VideoListMetricsRead from './model/VideoListMetricsRead';
import VideoMetricsRead from './model/VideoMetricsRead';
import VideoOriginWriteEmbed from './model/VideoOriginWriteEmbed';
import VideoRead from './model/VideoRead';
import VideoReadEmbed from './model/VideoReadEmbed';
import VideoState from './model/VideoState';
import VideoStateUpdate from './model/VideoStateUpdate';
import VideoUpdate from './model/VideoUpdate';
import VideoUpdateRead from './model/VideoUpdateRead';
import VideoVersionList from './model/VideoVersionList';
import VideoVersionRead from './model/VideoVersionRead';
import VideoVersionWrite from './model/VideoVersionWrite';
import VoteCreate from './model/VoteCreate';
import VoteList from './model/VoteList';
import VoteRead from './model/VoteRead';
import VoteUpdate from './model/VoteUpdate';
import ArticleApi from './api/ArticleApi';
import AttributeDefinitionApi from './api/AttributeDefinitionApi';
import BrandApi from './api/BrandApi';
import CommentApi from './api/CommentApi';
import FileApi from './api/FileApi';
import ImageApi from './api/ImageApi';
import ImageConfigApi from './api/ImageConfigApi';
import IngredientApi from './api/IngredientApi';
import MetadataApi from './api/MetadataApi';
import MetricsApi from './api/MetricsApi';
import ProductApi from './api/ProductApi';
import RecipeApi from './api/RecipeApi';
import SitemapApi from './api/SitemapApi';
import StateApi from './api/StateApi';
import TaxonApi from './api/TaxonApi';
import TaxonomyApi from './api/TaxonomyApi';
import TenantApi from './api/TenantApi';
import UserApi from './api/UserApi';
import VersionsApi from './api/VersionsApi';
import VideoApi from './api/VideoApi';
import VoteApi from './api/VoteApi';


/**
* JS API client generated by OpenAPI Generator.<br>
* The <code>index</code> module provides access to constructors for all the classes which comprise the public API.
* <p>
* An AMD (recommended!) or CommonJS application will generally do something equivalent to the following:
* <pre>
* var PodravkaIo = require('index'); // See note below*.
* var xxxSvc = new PodravkaIo.XxxApi(); // Allocate the API class we're going to use.
* var yyyModel = new PodravkaIo.Yyy(); // Construct a model instance.
* yyyModel.someProperty = 'someValue';
* ...
* var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
* ...
* </pre>
* <em>*NOTE: For a top-level AMD script, use require(['index'], function(){...})
* and put the application logic within the callback function.</em>
* </p>
* <p>
* A non-AMD browser application (discouraged) might do something like this:
* <pre>
* var xxxSvc = new PodravkaIo.XxxApi(); // Allocate the API class we're going to use.
* var yyy = new PodravkaIo.Yyy(); // Construct a model instance.
* yyyModel.someProperty = 'someValue';
* ...
* var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
* ...
* </pre>
* </p>
* @module index
* @version 1.7.2
*/
export {
    /**
     * The ApiClient constructor.
     * @property {module:ApiClient}
     */
    ApiClient,

    /**
     * The AccountReadEmbed model constructor.
     * @property {module:model/AccountReadEmbed}
     */
    AccountReadEmbed,

    /**
     * The ArticleCreate model constructor.
     * @property {module:model/ArticleCreate}
     */
    ArticleCreate,

    /**
     * The ArticleList model constructor.
     * @property {module:model/ArticleList}
     */
    ArticleList,

    /**
     * The ArticleListMetricsRead model constructor.
     * @property {module:model/ArticleListMetricsRead}
     */
    ArticleListMetricsRead,

    /**
     * The ArticleMetricsRead model constructor.
     * @property {module:model/ArticleMetricsRead}
     */
    ArticleMetricsRead,

    /**
     * The ArticleOriginWriteEmbed model constructor.
     * @property {module:model/ArticleOriginWriteEmbed}
     */
    ArticleOriginWriteEmbed,

    /**
     * The ArticleRead model constructor.
     * @property {module:model/ArticleRead}
     */
    ArticleRead,

    /**
     * The ArticleState model constructor.
     * @property {module:model/ArticleState}
     */
    ArticleState,

    /**
     * The ArticleStateUpdate model constructor.
     * @property {module:model/ArticleStateUpdate}
     */
    ArticleStateUpdate,

    /**
     * The ArticleUpdate model constructor.
     * @property {module:model/ArticleUpdate}
     */
    ArticleUpdate,

    /**
     * The ArticleVersionList model constructor.
     * @property {module:model/ArticleVersionList}
     */
    ArticleVersionList,

    /**
     * The ArticleVersionRead model constructor.
     * @property {module:model/ArticleVersionRead}
     */
    ArticleVersionRead,

    /**
     * The ArticleVersionWrite model constructor.
     * @property {module:model/ArticleVersionWrite}
     */
    ArticleVersionWrite,

    /**
     * The AttributeDefinitionCreate model constructor.
     * @property {module:model/AttributeDefinitionCreate}
     */
    AttributeDefinitionCreate,

    /**
     * The AttributeDefinitionCreateOptions model constructor.
     * @property {module:model/AttributeDefinitionCreateOptions}
     */
    AttributeDefinitionCreateOptions,

    /**
     * The AttributeDefinitionList model constructor.
     * @property {module:model/AttributeDefinitionList}
     */
    AttributeDefinitionList,

    /**
     * The AttributeDefinitionRead model constructor.
     * @property {module:model/AttributeDefinitionRead}
     */
    AttributeDefinitionRead,

    /**
     * The BadRequestError model constructor.
     * @property {module:model/BadRequestError}
     */
    BadRequestError,

    /**
     * The BadRequestErrorViolations model constructor.
     * @property {module:model/BadRequestErrorViolations}
     */
    BadRequestErrorViolations,

    /**
     * The BaseReadEmbed model constructor.
     * @property {module:model/BaseReadEmbed}
     */
    BaseReadEmbed,

    /**
     * The BrandCreate model constructor.
     * @property {module:model/BrandCreate}
     */
    BrandCreate,

    /**
     * The BrandList model constructor.
     * @property {module:model/BrandList}
     */
    BrandList,

    /**
     * The BrandListMetricsRead model constructor.
     * @property {module:model/BrandListMetricsRead}
     */
    BrandListMetricsRead,

    /**
     * The BrandMetricsRead model constructor.
     * @property {module:model/BrandMetricsRead}
     */
    BrandMetricsRead,

    /**
     * The BrandOriginWriteEmbed model constructor.
     * @property {module:model/BrandOriginWriteEmbed}
     */
    BrandOriginWriteEmbed,

    /**
     * The BrandRead model constructor.
     * @property {module:model/BrandRead}
     */
    BrandRead,

    /**
     * The BrandReadEmbed model constructor.
     * @property {module:model/BrandReadEmbed}
     */
    BrandReadEmbed,

    /**
     * The BrandState model constructor.
     * @property {module:model/BrandState}
     */
    BrandState,

    /**
     * The BrandStateUpdate model constructor.
     * @property {module:model/BrandStateUpdate}
     */
    BrandStateUpdate,

    /**
     * The BrandUpdate model constructor.
     * @property {module:model/BrandUpdate}
     */
    BrandUpdate,

    /**
     * The BrandVersionList model constructor.
     * @property {module:model/BrandVersionList}
     */
    BrandVersionList,

    /**
     * The BrandVersionRead model constructor.
     * @property {module:model/BrandVersionRead}
     */
    BrandVersionRead,

    /**
     * The BrandVersionWrite model constructor.
     * @property {module:model/BrandVersionWrite}
     */
    BrandVersionWrite,

    /**
     * The Comment model constructor.
     * @property {module:model/Comment}
     */
    Comment,

    /**
     * The CommentCreate model constructor.
     * @property {module:model/CommentCreate}
     */
    CommentCreate,

    /**
     * The CommentList model constructor.
     * @property {module:model/CommentList}
     */
    CommentList,

    /**
     * The CommentRead model constructor.
     * @property {module:model/CommentRead}
     */
    CommentRead,

    /**
     * The CommentUpdate model constructor.
     * @property {module:model/CommentUpdate}
     */
    CommentUpdate,

    /**
     * The CommentVersionList model constructor.
     * @property {module:model/CommentVersionList}
     */
    CommentVersionList,

    /**
     * The CommentVersionRead model constructor.
     * @property {module:model/CommentVersionRead}
     */
    CommentVersionRead,

    /**
     * The CommentVersionWrite model constructor.
     * @property {module:model/CommentVersionWrite}
     */
    CommentVersionWrite,

    /**
     * The ContentSitemapNodeCreate model constructor.
     * @property {module:model/ContentSitemapNodeCreate}
     */
    ContentSitemapNodeCreate,

    /**
     * The ContentSitemapNodeList model constructor.
     * @property {module:model/ContentSitemapNodeList}
     */
    ContentSitemapNodeList,

    /**
     * The ContentSitemapNodeRead model constructor.
     * @property {module:model/ContentSitemapNodeRead}
     */
    ContentSitemapNodeRead,

    /**
     * The ContentTaxonCreate model constructor.
     * @property {module:model/ContentTaxonCreate}
     */
    ContentTaxonCreate,

    /**
     * The ContentTaxonList model constructor.
     * @property {module:model/ContentTaxonList}
     */
    ContentTaxonList,

    /**
     * The ContentTaxonRead model constructor.
     * @property {module:model/ContentTaxonRead}
     */
    ContentTaxonRead,

    /**
     * The CurrentUser model constructor.
     * @property {module:model/CurrentUser}
     */
    CurrentUser,

    /**
     * The EnergyReadEmbed model constructor.
     * @property {module:model/EnergyReadEmbed}
     */
    EnergyReadEmbed,

    /**
     * The FileCreate model constructor.
     * @property {module:model/FileCreate}
     */
    FileCreate,

    /**
     * The FileCreateRead model constructor.
     * @property {module:model/FileCreateRead}
     */
    FileCreateRead,

    /**
     * The FileList model constructor.
     * @property {module:model/FileList}
     */
    FileList,

    /**
     * The FileListMetricsRead model constructor.
     * @property {module:model/FileListMetricsRead}
     */
    FileListMetricsRead,

    /**
     * The FileMetricsRead model constructor.
     * @property {module:model/FileMetricsRead}
     */
    FileMetricsRead,

    /**
     * The FileOriginWriteEmbed model constructor.
     * @property {module:model/FileOriginWriteEmbed}
     */
    FileOriginWriteEmbed,

    /**
     * The FileRead model constructor.
     * @property {module:model/FileRead}
     */
    FileRead,

    /**
     * The FileState model constructor.
     * @property {module:model/FileState}
     */
    FileState,

    /**
     * The FileStateUpdate model constructor.
     * @property {module:model/FileStateUpdate}
     */
    FileStateUpdate,

    /**
     * The FileUpdate model constructor.
     * @property {module:model/FileUpdate}
     */
    FileUpdate,

    /**
     * The FileUpdateRead model constructor.
     * @property {module:model/FileUpdateRead}
     */
    FileUpdateRead,

    /**
     * The FileVersionList model constructor.
     * @property {module:model/FileVersionList}
     */
    FileVersionList,

    /**
     * The FileVersionRead model constructor.
     * @property {module:model/FileVersionRead}
     */
    FileVersionRead,

    /**
     * The FileVersionWrite model constructor.
     * @property {module:model/FileVersionWrite}
     */
    FileVersionWrite,

    /**
     * The ForbiddenError model constructor.
     * @property {module:model/ForbiddenError}
     */
    ForbiddenError,

    /**
     * The ImageConfigAspectRatioCreate model constructor.
     * @property {module:model/ImageConfigAspectRatioCreate}
     */
    ImageConfigAspectRatioCreate,

    /**
     * The ImageConfigAspectRatioList model constructor.
     * @property {module:model/ImageConfigAspectRatioList}
     */
    ImageConfigAspectRatioList,

    /**
     * The ImageConfigAspectRatioOriginWriteEmbed model constructor.
     * @property {module:model/ImageConfigAspectRatioOriginWriteEmbed}
     */
    ImageConfigAspectRatioOriginWriteEmbed,

    /**
     * The ImageConfigAspectRatioRead model constructor.
     * @property {module:model/ImageConfigAspectRatioRead}
     */
    ImageConfigAspectRatioRead,

    /**
     * The ImageConfigInstanceReadEmbed model constructor.
     * @property {module:model/ImageConfigInstanceReadEmbed}
     */
    ImageConfigInstanceReadEmbed,

    /**
     * The ImageConfigInstanceWriteEmbed model constructor.
     * @property {module:model/ImageConfigInstanceWriteEmbed}
     */
    ImageConfigInstanceWriteEmbed,

    /**
     * The ImageConfigVariationCreate model constructor.
     * @property {module:model/ImageConfigVariationCreate}
     */
    ImageConfigVariationCreate,

    /**
     * The ImageConfigVariationCreateFilters model constructor.
     * @property {module:model/ImageConfigVariationCreateFilters}
     */
    ImageConfigVariationCreateFilters,

    /**
     * The ImageConfigVariationList model constructor.
     * @property {module:model/ImageConfigVariationList}
     */
    ImageConfigVariationList,

    /**
     * The ImageConfigVariationOriginWriteEmbed model constructor.
     * @property {module:model/ImageConfigVariationOriginWriteEmbed}
     */
    ImageConfigVariationOriginWriteEmbed,

    /**
     * The ImageConfigVariationRead model constructor.
     * @property {module:model/ImageConfigVariationRead}
     */
    ImageConfigVariationRead,

    /**
     * The ImageConfigVariationUpdate model constructor.
     * @property {module:model/ImageConfigVariationUpdate}
     */
    ImageConfigVariationUpdate,

    /**
     * The ImageCreate model constructor.
     * @property {module:model/ImageCreate}
     */
    ImageCreate,

    /**
     * The ImageCreateRead model constructor.
     * @property {module:model/ImageCreateRead}
     */
    ImageCreateRead,

    /**
     * The ImageFormatReadEmbed model constructor.
     * @property {module:model/ImageFormatReadEmbed}
     */
    ImageFormatReadEmbed,

    /**
     * The ImageList model constructor.
     * @property {module:model/ImageList}
     */
    ImageList,

    /**
     * The ImageListMetricsRead model constructor.
     * @property {module:model/ImageListMetricsRead}
     */
    ImageListMetricsRead,

    /**
     * The ImageMetadata model constructor.
     * @property {module:model/ImageMetadata}
     */
    ImageMetadata,

    /**
     * The ImageMetadataUpdate model constructor.
     * @property {module:model/ImageMetadataUpdate}
     */
    ImageMetadataUpdate,

    /**
     * The ImageMetricsRead model constructor.
     * @property {module:model/ImageMetricsRead}
     */
    ImageMetricsRead,

    /**
     * The ImageOriginWriteEmbed model constructor.
     * @property {module:model/ImageOriginWriteEmbed}
     */
    ImageOriginWriteEmbed,

    /**
     * The ImageRead model constructor.
     * @property {module:model/ImageRead}
     */
    ImageRead,

    /**
     * The ImageReadEmbed model constructor.
     * @property {module:model/ImageReadEmbed}
     */
    ImageReadEmbed,

    /**
     * The ImageState model constructor.
     * @property {module:model/ImageState}
     */
    ImageState,

    /**
     * The ImageStateUpdate model constructor.
     * @property {module:model/ImageStateUpdate}
     */
    ImageStateUpdate,

    /**
     * The ImageSwatchColorReadEmbed model constructor.
     * @property {module:model/ImageSwatchColorReadEmbed}
     */
    ImageSwatchColorReadEmbed,

    /**
     * The ImageUpdate model constructor.
     * @property {module:model/ImageUpdate}
     */
    ImageUpdate,

    /**
     * The ImageUpdateRead model constructor.
     * @property {module:model/ImageUpdateRead}
     */
    ImageUpdateRead,

    /**
     * The ImageVariationReadEmbed model constructor.
     * @property {module:model/ImageVariationReadEmbed}
     */
    ImageVariationReadEmbed,

    /**
     * The ImageVariationReadEmbedUrlVars model constructor.
     * @property {module:model/ImageVariationReadEmbedUrlVars}
     */
    ImageVariationReadEmbedUrlVars,

    /**
     * The ImageVariationReadEmbedUrlVarsInstance model constructor.
     * @property {module:model/ImageVariationReadEmbedUrlVarsInstance}
     */
    ImageVariationReadEmbedUrlVarsInstance,

    /**
     * The ImageVersionList model constructor.
     * @property {module:model/ImageVersionList}
     */
    ImageVersionList,

    /**
     * The ImageVersionRead model constructor.
     * @property {module:model/ImageVersionRead}
     */
    ImageVersionRead,

    /**
     * The ImageVersionWrite model constructor.
     * @property {module:model/ImageVersionWrite}
     */
    ImageVersionWrite,

    /**
     * The IngredientCreate model constructor.
     * @property {module:model/IngredientCreate}
     */
    IngredientCreate,

    /**
     * The IngredientList model constructor.
     * @property {module:model/IngredientList}
     */
    IngredientList,

    /**
     * The IngredientListMetricsRead model constructor.
     * @property {module:model/IngredientListMetricsRead}
     */
    IngredientListMetricsRead,

    /**
     * The IngredientMetricsRead model constructor.
     * @property {module:model/IngredientMetricsRead}
     */
    IngredientMetricsRead,

    /**
     * The IngredientNutritionReadEmbed model constructor.
     * @property {module:model/IngredientNutritionReadEmbed}
     */
    IngredientNutritionReadEmbed,

    /**
     * The IngredientNutritionWriteEmbed model constructor.
     * @property {module:model/IngredientNutritionWriteEmbed}
     */
    IngredientNutritionWriteEmbed,

    /**
     * The IngredientOriginWriteEmbed model constructor.
     * @property {module:model/IngredientOriginWriteEmbed}
     */
    IngredientOriginWriteEmbed,

    /**
     * The IngredientRead model constructor.
     * @property {module:model/IngredientRead}
     */
    IngredientRead,

    /**
     * The IngredientReadEmbed model constructor.
     * @property {module:model/IngredientReadEmbed}
     */
    IngredientReadEmbed,

    /**
     * The IngredientState model constructor.
     * @property {module:model/IngredientState}
     */
    IngredientState,

    /**
     * The IngredientStateUpdate model constructor.
     * @property {module:model/IngredientStateUpdate}
     */
    IngredientStateUpdate,

    /**
     * The IngredientUpdate model constructor.
     * @property {module:model/IngredientUpdate}
     */
    IngredientUpdate,

    /**
     * The IngredientVersionList model constructor.
     * @property {module:model/IngredientVersionList}
     */
    IngredientVersionList,

    /**
     * The IngredientVersionRead model constructor.
     * @property {module:model/IngredientVersionRead}
     */
    IngredientVersionRead,

    /**
     * The IngredientVersionWrite model constructor.
     * @property {module:model/IngredientVersionWrite}
     */
    IngredientVersionWrite,

    /**
     * The InlineObject model constructor.
     * @property {module:model/InlineObject}
     */
    InlineObject,

    /**
     * The InlineObject1 model constructor.
     * @property {module:model/InlineObject1}
     */
    InlineObject1,

    /**
     * The InlineObject10 model constructor.
     * @property {module:model/InlineObject10}
     */
    InlineObject10,

    /**
     * The InlineObject11 model constructor.
     * @property {module:model/InlineObject11}
     */
    InlineObject11,

    /**
     * The InlineObject12 model constructor.
     * @property {module:model/InlineObject12}
     */
    InlineObject12,

    /**
     * The InlineObject13 model constructor.
     * @property {module:model/InlineObject13}
     */
    InlineObject13,

    /**
     * The InlineObject14 model constructor.
     * @property {module:model/InlineObject14}
     */
    InlineObject14,

    /**
     * The InlineObject15 model constructor.
     * @property {module:model/InlineObject15}
     */
    InlineObject15,

    /**
     * The InlineObject16 model constructor.
     * @property {module:model/InlineObject16}
     */
    InlineObject16,

    /**
     * The InlineObject17 model constructor.
     * @property {module:model/InlineObject17}
     */
    InlineObject17,

    /**
     * The InlineObject18 model constructor.
     * @property {module:model/InlineObject18}
     */
    InlineObject18,

    /**
     * The InlineObject19 model constructor.
     * @property {module:model/InlineObject19}
     */
    InlineObject19,

    /**
     * The InlineObject2 model constructor.
     * @property {module:model/InlineObject2}
     */
    InlineObject2,

    /**
     * The InlineObject20 model constructor.
     * @property {module:model/InlineObject20}
     */
    InlineObject20,

    /**
     * The InlineObject21 model constructor.
     * @property {module:model/InlineObject21}
     */
    InlineObject21,

    /**
     * The InlineObject22 model constructor.
     * @property {module:model/InlineObject22}
     */
    InlineObject22,

    /**
     * The InlineObject23 model constructor.
     * @property {module:model/InlineObject23}
     */
    InlineObject23,

    /**
     * The InlineObject24 model constructor.
     * @property {module:model/InlineObject24}
     */
    InlineObject24,

    /**
     * The InlineObject25 model constructor.
     * @property {module:model/InlineObject25}
     */
    InlineObject25,

    /**
     * The InlineObject26 model constructor.
     * @property {module:model/InlineObject26}
     */
    InlineObject26,

    /**
     * The InlineObject27 model constructor.
     * @property {module:model/InlineObject27}
     */
    InlineObject27,

    /**
     * The InlineObject3 model constructor.
     * @property {module:model/InlineObject3}
     */
    InlineObject3,

    /**
     * The InlineObject4 model constructor.
     * @property {module:model/InlineObject4}
     */
    InlineObject4,

    /**
     * The InlineObject5 model constructor.
     * @property {module:model/InlineObject5}
     */
    InlineObject5,

    /**
     * The InlineObject6 model constructor.
     * @property {module:model/InlineObject6}
     */
    InlineObject6,

    /**
     * The InlineObject7 model constructor.
     * @property {module:model/InlineObject7}
     */
    InlineObject7,

    /**
     * The InlineObject8 model constructor.
     * @property {module:model/InlineObject8}
     */
    InlineObject8,

    /**
     * The InlineObject9 model constructor.
     * @property {module:model/InlineObject9}
     */
    InlineObject9,

    /**
     * The InlineResponse200 model constructor.
     * @property {module:model/InlineResponse200}
     */
    InlineResponse200,

    /**
     * The NotAcceptableError model constructor.
     * @property {module:model/NotAcceptableError}
     */
    NotAcceptableError,

    /**
     * The NotFoundError model constructor.
     * @property {module:model/NotFoundError}
     */
    NotFoundError,

    /**
     * The NutrientReadEmbed model constructor.
     * @property {module:model/NutrientReadEmbed}
     */
    NutrientReadEmbed,

    /**
     * The NutrientWriteEmbed model constructor.
     * @property {module:model/NutrientWriteEmbed}
     */
    NutrientWriteEmbed,

    /**
     * The PointOfInterestReadEmbed model constructor.
     * @property {module:model/PointOfInterestReadEmbed}
     */
    PointOfInterestReadEmbed,

    /**
     * The PointOfInterestWriteEmbed model constructor.
     * @property {module:model/PointOfInterestWriteEmbed}
     */
    PointOfInterestWriteEmbed,

    /**
     * The ProductCreate model constructor.
     * @property {module:model/ProductCreate}
     */
    ProductCreate,

    /**
     * The ProductList model constructor.
     * @property {module:model/ProductList}
     */
    ProductList,

    /**
     * The ProductListMetricsRead model constructor.
     * @property {module:model/ProductListMetricsRead}
     */
    ProductListMetricsRead,

    /**
     * The ProductMetricsRead model constructor.
     * @property {module:model/ProductMetricsRead}
     */
    ProductMetricsRead,

    /**
     * The ProductNutritionReadEmbed model constructor.
     * @property {module:model/ProductNutritionReadEmbed}
     */
    ProductNutritionReadEmbed,

    /**
     * The ProductNutritionWriteEmbed model constructor.
     * @property {module:model/ProductNutritionWriteEmbed}
     */
    ProductNutritionWriteEmbed,

    /**
     * The ProductOriginWriteEmbed model constructor.
     * @property {module:model/ProductOriginWriteEmbed}
     */
    ProductOriginWriteEmbed,

    /**
     * The ProductRead model constructor.
     * @property {module:model/ProductRead}
     */
    ProductRead,

    /**
     * The ProductReadEmbed model constructor.
     * @property {module:model/ProductReadEmbed}
     */
    ProductReadEmbed,

    /**
     * The ProductState model constructor.
     * @property {module:model/ProductState}
     */
    ProductState,

    /**
     * The ProductStateUpdate model constructor.
     * @property {module:model/ProductStateUpdate}
     */
    ProductStateUpdate,

    /**
     * The ProductUpdate model constructor.
     * @property {module:model/ProductUpdate}
     */
    ProductUpdate,

    /**
     * The ProductVersionList model constructor.
     * @property {module:model/ProductVersionList}
     */
    ProductVersionList,

    /**
     * The ProductVersionRead model constructor.
     * @property {module:model/ProductVersionRead}
     */
    ProductVersionRead,

    /**
     * The ProductVersionWrite model constructor.
     * @property {module:model/ProductVersionWrite}
     */
    ProductVersionWrite,

    /**
     * The RecipeCreate model constructor.
     * @property {module:model/RecipeCreate}
     */
    RecipeCreate,

    /**
     * The RecipeIngredientGroupReadEmbed model constructor.
     * @property {module:model/RecipeIngredientGroupReadEmbed}
     */
    RecipeIngredientGroupReadEmbed,

    /**
     * The RecipeIngredientGroupWriteEmbed model constructor.
     * @property {module:model/RecipeIngredientGroupWriteEmbed}
     */
    RecipeIngredientGroupWriteEmbed,

    /**
     * The RecipeIngredientReadEmbed model constructor.
     * @property {module:model/RecipeIngredientReadEmbed}
     */
    RecipeIngredientReadEmbed,

    /**
     * The RecipeIngredientWriteEmbed model constructor.
     * @property {module:model/RecipeIngredientWriteEmbed}
     */
    RecipeIngredientWriteEmbed,

    /**
     * The RecipeList model constructor.
     * @property {module:model/RecipeList}
     */
    RecipeList,

    /**
     * The RecipeListMetricsRead model constructor.
     * @property {module:model/RecipeListMetricsRead}
     */
    RecipeListMetricsRead,

    /**
     * The RecipeMetricsRead model constructor.
     * @property {module:model/RecipeMetricsRead}
     */
    RecipeMetricsRead,

    /**
     * The RecipeNutritionReadEmbed model constructor.
     * @property {module:model/RecipeNutritionReadEmbed}
     */
    RecipeNutritionReadEmbed,

    /**
     * The RecipeNutritionWriteEmbed model constructor.
     * @property {module:model/RecipeNutritionWriteEmbed}
     */
    RecipeNutritionWriteEmbed,

    /**
     * The RecipeOriginWriteEmbed model constructor.
     * @property {module:model/RecipeOriginWriteEmbed}
     */
    RecipeOriginWriteEmbed,

    /**
     * The RecipePreparationStepGroupReadEmbed model constructor.
     * @property {module:model/RecipePreparationStepGroupReadEmbed}
     */
    RecipePreparationStepGroupReadEmbed,

    /**
     * The RecipePreparationStepGroupWriteEmbed model constructor.
     * @property {module:model/RecipePreparationStepGroupWriteEmbed}
     */
    RecipePreparationStepGroupWriteEmbed,

    /**
     * The RecipePreparationStepReadEmbed model constructor.
     * @property {module:model/RecipePreparationStepReadEmbed}
     */
    RecipePreparationStepReadEmbed,

    /**
     * The RecipePreparationStepWriteEmbed model constructor.
     * @property {module:model/RecipePreparationStepWriteEmbed}
     */
    RecipePreparationStepWriteEmbed,

    /**
     * The RecipeRead model constructor.
     * @property {module:model/RecipeRead}
     */
    RecipeRead,

    /**
     * The RecipeState model constructor.
     * @property {module:model/RecipeState}
     */
    RecipeState,

    /**
     * The RecipeStateUpdate model constructor.
     * @property {module:model/RecipeStateUpdate}
     */
    RecipeStateUpdate,

    /**
     * The RecipeUpdate model constructor.
     * @property {module:model/RecipeUpdate}
     */
    RecipeUpdate,

    /**
     * The RecipeVersionList model constructor.
     * @property {module:model/RecipeVersionList}
     */
    RecipeVersionList,

    /**
     * The RecipeVersionRead model constructor.
     * @property {module:model/RecipeVersionRead}
     */
    RecipeVersionRead,

    /**
     * The RecipeVersionWrite model constructor.
     * @property {module:model/RecipeVersionWrite}
     */
    RecipeVersionWrite,

    /**
     * The ServiceUnavailableError model constructor.
     * @property {module:model/ServiceUnavailableError}
     */
    ServiceUnavailableError,

    /**
     * The ShortNameApproveCommentRead model constructor.
     * @property {module:model/ShortNameApproveCommentRead}
     */
    ShortNameApproveCommentRead,

    /**
     * The SitemapCreate model constructor.
     * @property {module:model/SitemapCreate}
     */
    SitemapCreate,

    /**
     * The SitemapList model constructor.
     * @property {module:model/SitemapList}
     */
    SitemapList,

    /**
     * The SitemapNodeCreate model constructor.
     * @property {module:model/SitemapNodeCreate}
     */
    SitemapNodeCreate,

    /**
     * The SitemapNodeList model constructor.
     * @property {module:model/SitemapNodeList}
     */
    SitemapNodeList,

    /**
     * The SitemapNodeRead model constructor.
     * @property {module:model/SitemapNodeRead}
     */
    SitemapNodeRead,

    /**
     * The SitemapNodeReadEmbed model constructor.
     * @property {module:model/SitemapNodeReadEmbed}
     */
    SitemapNodeReadEmbed,

    /**
     * The SitemapNodeUpdate model constructor.
     * @property {module:model/SitemapNodeUpdate}
     */
    SitemapNodeUpdate,

    /**
     * The SitemapNodeVersionList model constructor.
     * @property {module:model/SitemapNodeVersionList}
     */
    SitemapNodeVersionList,

    /**
     * The SitemapNodeVersionRead model constructor.
     * @property {module:model/SitemapNodeVersionRead}
     */
    SitemapNodeVersionRead,

    /**
     * The SitemapNodeVersionWrite model constructor.
     * @property {module:model/SitemapNodeVersionWrite}
     */
    SitemapNodeVersionWrite,

    /**
     * The SitemapRead model constructor.
     * @property {module:model/SitemapRead}
     */
    SitemapRead,

    /**
     * The SitemapUpdate model constructor.
     * @property {module:model/SitemapUpdate}
     */
    SitemapUpdate,

    /**
     * The TaxonBagCreate model constructor.
     * @property {module:model/TaxonBagCreate}
     */
    TaxonBagCreate,

    /**
     * The TaxonBagList model constructor.
     * @property {module:model/TaxonBagList}
     */
    TaxonBagList,

    /**
     * The TaxonBagRead model constructor.
     * @property {module:model/TaxonBagRead}
     */
    TaxonBagRead,

    /**
     * The TaxonBagUpdate model constructor.
     * @property {module:model/TaxonBagUpdate}
     */
    TaxonBagUpdate,

    /**
     * The TaxonCreate model constructor.
     * @property {module:model/TaxonCreate}
     */
    TaxonCreate,

    /**
     * The TaxonList model constructor.
     * @property {module:model/TaxonList}
     */
    TaxonList,

    /**
     * The TaxonPositionWriteEmbed model constructor.
     * @property {module:model/TaxonPositionWriteEmbed}
     */
    TaxonPositionWriteEmbed,

    /**
     * The TaxonRead model constructor.
     * @property {module:model/TaxonRead}
     */
    TaxonRead,

    /**
     * The TaxonReadEmbed model constructor.
     * @property {module:model/TaxonReadEmbed}
     */
    TaxonReadEmbed,

    /**
     * The TaxonState model constructor.
     * @property {module:model/TaxonState}
     */
    TaxonState,

    /**
     * The TaxonStateUpdate model constructor.
     * @property {module:model/TaxonStateUpdate}
     */
    TaxonStateUpdate,

    /**
     * The TaxonUpdate model constructor.
     * @property {module:model/TaxonUpdate}
     */
    TaxonUpdate,

    /**
     * The TaxonVersionList model constructor.
     * @property {module:model/TaxonVersionList}
     */
    TaxonVersionList,

    /**
     * The TaxonVersionRead model constructor.
     * @property {module:model/TaxonVersionRead}
     */
    TaxonVersionRead,

    /**
     * The TaxonVersionWrite model constructor.
     * @property {module:model/TaxonVersionWrite}
     */
    TaxonVersionWrite,

    /**
     * The TaxonomyCreate model constructor.
     * @property {module:model/TaxonomyCreate}
     */
    TaxonomyCreate,

    /**
     * The TaxonomyList model constructor.
     * @property {module:model/TaxonomyList}
     */
    TaxonomyList,

    /**
     * The TaxonomyRead model constructor.
     * @property {module:model/TaxonomyRead}
     */
    TaxonomyRead,

    /**
     * The TaxonomyReadEmbed model constructor.
     * @property {module:model/TaxonomyReadEmbed}
     */
    TaxonomyReadEmbed,

    /**
     * The TaxonomyUpdate model constructor.
     * @property {module:model/TaxonomyUpdate}
     */
    TaxonomyUpdate,

    /**
     * The TenantRead model constructor.
     * @property {module:model/TenantRead}
     */
    TenantRead,

    /**
     * The TenantReadClients model constructor.
     * @property {module:model/TenantReadClients}
     */
    TenantReadClients,

    /**
     * The UnauthorizedError model constructor.
     * @property {module:model/UnauthorizedError}
     */
    UnauthorizedError,

    /**
     * The UserGroupCreate model constructor.
     * @property {module:model/UserGroupCreate}
     */
    UserGroupCreate,

    /**
     * The UserGroupList model constructor.
     * @property {module:model/UserGroupList}
     */
    UserGroupList,

    /**
     * The UserGroupRead model constructor.
     * @property {module:model/UserGroupRead}
     */
    UserGroupRead,

    /**
     * The UserGroupUpdate model constructor.
     * @property {module:model/UserGroupUpdate}
     */
    UserGroupUpdate,

    /**
     * The UserList model constructor.
     * @property {module:model/UserList}
     */
    UserList,

    /**
     * The UserRead model constructor.
     * @property {module:model/UserRead}
     */
    UserRead,

    /**
     * The UserReadEmbed model constructor.
     * @property {module:model/UserReadEmbed}
     */
    UserReadEmbed,

    /**
     * The UserUpdate model constructor.
     * @property {module:model/UserUpdate}
     */
    UserUpdate,

    /**
     * The VersionReadEmbed model constructor.
     * @property {module:model/VersionReadEmbed}
     */
    VersionReadEmbed,

    /**
     * The VideoCreate model constructor.
     * @property {module:model/VideoCreate}
     */
    VideoCreate,

    /**
     * The VideoCreateRead model constructor.
     * @property {module:model/VideoCreateRead}
     */
    VideoCreateRead,

    /**
     * The VideoList model constructor.
     * @property {module:model/VideoList}
     */
    VideoList,

    /**
     * The VideoListMetricsRead model constructor.
     * @property {module:model/VideoListMetricsRead}
     */
    VideoListMetricsRead,

    /**
     * The VideoMetricsRead model constructor.
     * @property {module:model/VideoMetricsRead}
     */
    VideoMetricsRead,

    /**
     * The VideoOriginWriteEmbed model constructor.
     * @property {module:model/VideoOriginWriteEmbed}
     */
    VideoOriginWriteEmbed,

    /**
     * The VideoRead model constructor.
     * @property {module:model/VideoRead}
     */
    VideoRead,

    /**
     * The VideoReadEmbed model constructor.
     * @property {module:model/VideoReadEmbed}
     */
    VideoReadEmbed,

    /**
     * The VideoState model constructor.
     * @property {module:model/VideoState}
     */
    VideoState,

    /**
     * The VideoStateUpdate model constructor.
     * @property {module:model/VideoStateUpdate}
     */
    VideoStateUpdate,

    /**
     * The VideoUpdate model constructor.
     * @property {module:model/VideoUpdate}
     */
    VideoUpdate,

    /**
     * The VideoUpdateRead model constructor.
     * @property {module:model/VideoUpdateRead}
     */
    VideoUpdateRead,

    /**
     * The VideoVersionList model constructor.
     * @property {module:model/VideoVersionList}
     */
    VideoVersionList,

    /**
     * The VideoVersionRead model constructor.
     * @property {module:model/VideoVersionRead}
     */
    VideoVersionRead,

    /**
     * The VideoVersionWrite model constructor.
     * @property {module:model/VideoVersionWrite}
     */
    VideoVersionWrite,

    /**
     * The VoteCreate model constructor.
     * @property {module:model/VoteCreate}
     */
    VoteCreate,

    /**
     * The VoteList model constructor.
     * @property {module:model/VoteList}
     */
    VoteList,

    /**
     * The VoteRead model constructor.
     * @property {module:model/VoteRead}
     */
    VoteRead,

    /**
     * The VoteUpdate model constructor.
     * @property {module:model/VoteUpdate}
     */
    VoteUpdate,

    /**
    * The ArticleApi service constructor.
    * @property {module:api/ArticleApi}
    */
    ArticleApi,

    /**
    * The AttributeDefinitionApi service constructor.
    * @property {module:api/AttributeDefinitionApi}
    */
    AttributeDefinitionApi,

    /**
    * The BrandApi service constructor.
    * @property {module:api/BrandApi}
    */
    BrandApi,

    /**
    * The CommentApi service constructor.
    * @property {module:api/CommentApi}
    */
    CommentApi,

    /**
    * The FileApi service constructor.
    * @property {module:api/FileApi}
    */
    FileApi,

    /**
    * The ImageApi service constructor.
    * @property {module:api/ImageApi}
    */
    ImageApi,

    /**
    * The ImageConfigApi service constructor.
    * @property {module:api/ImageConfigApi}
    */
    ImageConfigApi,

    /**
    * The IngredientApi service constructor.
    * @property {module:api/IngredientApi}
    */
    IngredientApi,

    /**
    * The MetadataApi service constructor.
    * @property {module:api/MetadataApi}
    */
    MetadataApi,

    /**
    * The MetricsApi service constructor.
    * @property {module:api/MetricsApi}
    */
    MetricsApi,

    /**
    * The ProductApi service constructor.
    * @property {module:api/ProductApi}
    */
    ProductApi,

    /**
    * The RecipeApi service constructor.
    * @property {module:api/RecipeApi}
    */
    RecipeApi,

    /**
    * The SitemapApi service constructor.
    * @property {module:api/SitemapApi}
    */
    SitemapApi,

    /**
    * The StateApi service constructor.
    * @property {module:api/StateApi}
    */
    StateApi,

    /**
    * The TaxonApi service constructor.
    * @property {module:api/TaxonApi}
    */
    TaxonApi,

    /**
    * The TaxonomyApi service constructor.
    * @property {module:api/TaxonomyApi}
    */
    TaxonomyApi,

    /**
    * The TenantApi service constructor.
    * @property {module:api/TenantApi}
    */
    TenantApi,

    /**
    * The UserApi service constructor.
    * @property {module:api/UserApi}
    */
    UserApi,

    /**
    * The VersionsApi service constructor.
    * @property {module:api/VersionsApi}
    */
    VersionsApi,

    /**
    * The VideoApi service constructor.
    * @property {module:api/VideoApi}
    */
    VideoApi,

    /**
    * The VoteApi service constructor.
    * @property {module:api/VoteApi}
    */
    VoteApi
};
